import styled from 'styled-components';

export const StyledEditUser = styled.div`
	height: fit-content;
	margin-bottom: 50px;

	.access {
		margin-top: 4px;
		display: flex;
		font-size: 13px;
		font-weight: 500;
		line-height: 150%;
		align-items: center;

		.indicator {
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: #d9dc32;
			margin-right: 6px;
			font-weight: 500;

			&.active {
				background-color: #1dc606;
			}
		}

		.resendIcon {
			margin-left: 6px;
			cursor: pointer;
		}

		.resendTimer {
			color: #abb3bb;
			font-weight: 500;
			margin-left: 6px;
		}
	}
`;

export const UpdateUserLoader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 50vh;

	svg {
		width: 148px;
		height: 23px;
		margin-bottom: 32px;
	}

	svg > path {
		fill: #0b93e3;
	}

	img {
		width: 40px;
		height: 40px;
	}
`;

export const StyledModal = styled.div`
	width: 456px !important;
	align-items: stretch !important;

	h4 {
		text-align: center;
		font-size: 32px;
		font-weight: 600;
		margin-bottom: 24px;
	}

	.body {
		text-align: center;
		font-weight: 500;
		font-size: 14px;
		color: #abb3bb;
		line-height: 1.5;
	}

	.buttons {
		display: flex;
		gap: 24px;
		margin-top: 24px;

		& > div {
			flex: 1;

			button {
				width: 100% !important;
			}
		}
	}
`;
